import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  Input
} from "reactstrap"
import BootstrapTable from 'react-bootstrap-table-next'
import ToolkitProvider from 'react-bootstrap-table2-toolkit'
import paginationFactory from 'react-bootstrap-table2-paginator'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Switch from 'react-switch';
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import rest from '../../../lib/rest'
import rotas from '../../../services/rotas'
import useToggle from "../../../lib/useToggle"
import Loading from 'lib/loading'
import FormCliente from './formCliente';
import useCentralLojas from '../../../lib/useCentralLojas'
import {homepage} from '../../../../package.json';
import ReactSelect from "../../../components/Form/Select/Select"

const formSwal = withReactContent(Swal)

const Clientes = () => {

  const colunas = [
    {
      dataField: 'cliente_id',
      text: 'Código',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'cliente',
      text: 'Cliente',
      align: 'left',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'cli_cpf',
      text: 'CPF',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'convenio',
      text: 'Convênio',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'cli_limite',
      text: 'LIMITE',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'cli_prazo',
      text: 'PRAZO',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'cli_celular',
      text: 'TELEFONE',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'cli_bloqueado',
      text: 'BLOQUEADO',
      headerStyle: { cursor: 'default' },
      hidden: true
    },
    {
      dataField: 'ativo',
      text: 'BLOQUEADO',
      headerStyle: { cursor: 'default' },
      formatter: (cellContent, row) => {
        return(
          <Switch
            id        = {'switch'+row.cliente_id}
            name      = {'switch'+row.cliente_id}
            className = "react-switch"
            height    = {15}
            width     = {35}
            checked   = {cellContent}
            onChange  = {() => toggleAtivoCliente(row.cliente_id)}
            onColor   ="#ff0000" // Vermelho quando ativado
            offColor  ="#008000" // Verde quando desativado
          />
        )
      }
    },
    {
      dataField: 'pdf',
      text: 'PDF',
      editable: false,
      formatter: (cellContent, row) => {
        return (
          <Button
            id        = {'btn'+row.cliente_id}
            name      = {'btn'+row.cliente_id}
            className = "btn-icon"
            title     = "Ficha Cadastral"
            color     = "info"
            size      = "md"
            type      = "button"
            onClick   = {() => gerarPDF(row)}
          >
            <i className="fas fa-file-pdf-o" />
          </Button>
        )
      }
    }
  ];

  const [loading, setLoading]             = useState(true)
  const [modal, setModal]                 = useToggle(false)
  const [filial_id, setFilial_id]         = useState('')
  const [listaConvenio, setListaConvenio] = useState([])
  const [listaCliente, setListaCliente]   = useState([])
  const [totalCliente, setTotalCliente]   = useState(0)
  const [cliente_id, setCliente_id]       = useState('')
  const [pagina, setPagina]               = useState(1);
  const [pesquisa, setPesquisa]           = useState('');
  const [pesquisaConv, setPesquisaConv]   = useState('');
  const [selectBloq, setSelectBloq]       = useState([]);
  const [tipo, setTipo]                   = useState('');
  const [filtrosPsq, setFiltrosPsq]       = useState({});

  const listaConvenios = () => {
    let lista = [{ id: '', title: 'NENHUM' }]

    try {
      const retorno = rest.get(rotas.convenios)
      retorno.then(ret => {
        
        if (ret != '' && ret.success == 'S' && ret.lista != '') {
          for (let i = 0; i < ret.lista.length; i++) {
            lista[i + 1] = { "id": ret.lista[i].convenio_id, "title": ret.lista[i].convenio }
          }
          setListaConvenio(lista)
        }
      })
      return (lista)
    } catch (err) {
      console.log(err)
    }
  }

  const gerarPDF = (row) => {
    let urlFicha  = homepage + '/webgestor/api/cadastros/clientes/pdf';
    let url       = rotas.clientes+'pdf/index.php'

    try{
      let rede    = sessionStorage.getItem('rede'),
          usuario = sessionStorage.getItem('usuario')
      
      const retorno = rest.post(url, {'cliente_id':row.cliente_id, 'convenio_id':row.convenio_id, 'rede':rede, 'usuario':usuario})
      retorno.then(ret => {
        if (ret.success == 'S') {
          const pdfWindow         = window.open()
          pdfWindow.location.href = urlFicha + ret.path

        }else{
          formSwal.fire('Erro na geração do PDF!', ret.msg, 'error')
        }
      })

      return (true)
    }catch(err){
      formSwal.fire('Erro!',err,'error')
      console.log(err)
    }
  }

  const format_cpf_cnpj = (val) => {
    if (val.toString().length <= 11) {
      let a = val.substr(0, 3),
          b = val.substr(3, 3),
          c = val.substr(6, 3),
          d = val.substr(9, 2)

      val = a + "." + b + "." + c + "-" + d

    } else {
      let a = val.substr(0, 2),
          b = val.substr(2, 3),
          c = val.substr(6, 3),
          d = val.substr(9, 4),
          e = val.substr(13, 2)

      val = a + "." + b + "." + c + "/" + d + "-" + e
    }

    return val
  }

  const listaClientes = () => {
    let lista = []
    try{
      const retorno = rest.get(rotas.clientes)
      retorno.then(ret => {
        if (ret != '' && ret.success && ret.success == 'S' && ret.lista!=''){
          lista = ret.lista

          for (let i = 0; i < lista.length; i++) {
            lista[i]['cli_limite']  = lista[i]['cli_limite'] !== '' ? parseFloat(lista[i]['cli_limite']).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) : parseFloat(0).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
            lista[i]['cli_cpf']     = lista[i]['cli_cpf'] !== '' ? format_cpf_cnpj(lista[i]['cli_cpf']) : ''

            if (lista[i]['cli_bloqueado'] == 'N' ) {
              lista[i]['cli_bloqueado'] = <div className="timeline-heading"><span className="badge badge-success badge-pill m-0 aberto">Não</span></div>
            }else{
              lista[i]['cli_bloqueado'] = <div className="timeline-heading"><span className="badge badge-danger badge-pill m-0 aberto">Sim</span></div>
            }
          }
          setListaCliente(lista)
          setTotalCliente(ret.total)
        }else{
          setListaCliente([])
          setTotalCliente(0)
        }
        setLoading(false)
      })
      return (lista)
    }catch(err){
      console.log(err)
    }
  }

  const pesquisaCliente = (type, filtros) => {

    setTipo(type);
    setFiltrosPsq(filtros);

    if(filtros == ''){
      type    = 'pagination'
      filtros = {
        page:1
      }
    }

    if (type == 'search') {
      filtros['page'] = 1
      setPagina(1)
    }else{
      setPagina(filtros.page)
    }
    
    filtros['searchText'] = pesquisa
    filtros['convenio']   = pesquisaConv

    let lista = []

    const url     = rotas.clientes,
          retorno = rest.post(url, filtros);

    retorno.then(ret => {
      if (ret != '' && ret.success && ret.success == 'S' && ret.lista!=''){
        lista = ret.lista

        for (let i = 0; i < lista.length; i++) {
          lista[i]['cli_limite'] = parseFloat(lista[i]['cli_limite']).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})

          if (lista[i]['cli_bloqueado'] == 'N' ) {
            lista[i]['cli_bloqueado'] = <div className="timeline-heading"><span className="badge badge-success badge-pill m-0 aberto">Não</span></div>
          }else{
            lista[i]['cli_bloqueado'] = <div className="timeline-heading"><span className="badge badge-danger badge-pill m-0 aberto">Sim</span></div>
          }
        }
        setListaCliente(lista)
        setTotalCliente(ret.total)
      }else{
        setListaCliente([])
        setTotalCliente(0)
      }
    })
  }

  const onChangePesquisa = (e) =>{
    setPesquisa(e.target.value)
  }

  const onChangePesquisaConv = (e) =>{
    setPesquisaConv(e.id)
  }

  const clienteAtivo = (cliente) => {
    try{
      const tipo      = cliente[0].ativo ? 'desbloqueado' : 'bloqueado',
            clienteid = cliente[0].cliente_id,
            nome      = cliente[0].cliente,
            ativo     = cliente[0].ativo,
            retorno   = rest.post(rotas.clientes+'ativar.php', cliente);

      retorno.then(ret => {
        if (ret != '' && ret.success == 'S') {
          toast.success('Cliente '+nome+', '+tipo+' com sucesso!', {
            position: "top-right",
            autoClose: 3500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else{
          toast.error('Cliente '+nome+', erro ao tentar ser '+tipo+'!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });

          setListaCliente((prevState) =>
            prevState.map((item) =>
              item.cliente_id === clienteid
                ? { ...item, ativo: ativo }
                : item
            )
          );
        }
      })
    }catch(err){
      console.log(err)
    }
  }

  const toggleAtivoCliente = (clienteId) => {
    const row = listaCliente.filter(cliente => cliente.cliente_id.includes(clienteId));
    clienteAtivo(row)

    setListaCliente((prevState) =>
      prevState.map((item) =>
        item.cliente_id === clienteId
          ? { ...item, ativo: !item.ativo }
          : item
      )
    );
  };

  useEffect(() => {
    const load = loading
    if (load === true) {
      listaConvenios()
      listaClientes()
    }
  }, [])

  useEffect(() => {
    console.log(pagina)
    if(modal == false){
        if((pagina) && (pagina != 1)){
        pesquisaCliente(tipo, filtrosPsq);
      }else{
        listaClientes();
      }
    }
  },[modal])

  const abreModal = (filial, cliente_id) => {
    setCliente_id(cliente_id)
    setFilial_id(filial)
    setModal()
  }

  if (loading) {
    return ( <Loading tipo='paginas' /> )
  }else {
    return (
      <div className="content">
        <ToastContainer />
        <Container>
          <Row>
            <Col md="12" className="p-0">
              <Card>
                <CardHeader>
                  <Row>
                    <Col>
                      <CardTitle>CADASTRO DE CLIENTES</CardTitle>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Modal
                    size    = 'xl'
                    isOpen  = {modal}
                  >
                    <ModalHeader>Cadastro de Clientes</ModalHeader>
                    <FormCliente
                      fechaModal    = {setModal}
                      cliente_id    = {cliente_id}
                      filial_id     = {useCentralLojas.centralLoja().filial_id}
                      setCliente_id = {setCliente_id}
                    ></FormCliente>

                  </Modal>
                  <ToolkitProvider
                    search
                    outline
                    keyField  = "cliente_id"
                    data      = {listaCliente}
                    columns   = {colunas}
                  >
                    {
                      props => (
                        <div>
                          <Container>
                            <Row>
                              <Col md="2">
                                <Button
                                  outline
                                  id        = "btnCad"
                                  className = "m-0 w-100"
                                  color     = "primary"
                                  style     = {{ padding: '9px 20px' }}
                                  onClick   = {() => abreModal(filial_id, '')}
                                >
                                  <i className="fas fa-plus" />
                                  Cadastrar
                                </Button>
                              </Col>

                              <Col md="4">
                                <ReactSelect
                                  id          = "convenio"
                                  name        = "convenio"
                                  placeholder = "Selecione o convênio"
                                  options     = {listaConvenio}
                                  onChange    = {onChangePesquisaConv}
                                >
                                </ReactSelect>
                              </Col>

                              <Col md="4">
                                <Input
                                  name        = "inputpesquisar"
                                  type        = "search"
                                  placeholder = "Buscar Cliente..."
                                  style       = {{ padding: '9px 15px' }}
                                  onChange    = {onChangePesquisa}
                                  onKeyPress  = {(e) =>{if(e.key === 'Enter'){pesquisaCliente('search','')}}}
                                ></Input>
                              </Col>

                              <Col md="2">
                                <Button 
                                  name      = "btnpesquisar"
                                  className = "m-0 w-100"
                                  color     = "success"                                    
                                  style     = {{ padding: '7px 15px' }}
                                  onClick   = {()=>{pesquisaCliente('search','')}}
                                >
                                  <i className="nc-icon nc-zoom-split" style={{ fontSize: '20px' }} />
                                </Button>
                              </Col>
                            </Row>
                          </Container>

                          <hr />

                          <BootstrapTable
                            striped
                            keyField          = 'cliente_id'
                            noDataIndication  = "Nenhum registro encontrado"
                            pagination        = {paginationFactory({
                                                  page: pagina,
                                                  sizePerPage: 10,
                                                  totalSize: parseInt(totalCliente),
                                                  hideSizePerPage: true,
                                                  hidePageListOnlyOnePage: true,
                                                  showTotal: false,
                                                })}
                            remote            = {{ search: true, pagination: true }}
                            onTableChange     = { pesquisaCliente }
                            data              = {listaCliente}
                            columns           = {colunas}
                            rowStyle          = {{ cursor: "pointer" }}
                            rowEvents         = {{ onDoubleClick: (e, row, rowIndex) => { abreModal(filial_id, row.cliente_id) } }}
                            {...props.baseProps}
                          />
                        </div>
                      )
                    }
                  </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default Clientes
